{
  "auth-process-pages": {
    "login-process-steps": {
      "step-1": {
        "title": "Username",
        "description": "Your email or telephone number"
      },
      "step-2": {
        "title": "Security",
        "description": "Please enter the required information"
      }
    },
    "register-process-steps": {
      "step-1": {
        "title": "Personal info",
        "description": "Please fill the information form"
      },
      "step-2": {
        "title": "Login data",
        "description": "Please set your login data"
      },
      "step-3": {
        "title": "Verify account",
        "description": "You will receive a confirmation pin by Email"
      },
      "step-4": {
        "title": "Account created",
        "description": "Your account is created!"
      }
    },
    "meta": {
      "login": {
        "title": "Login",
        "description": "Login to Beauty Booking"
      },
      "register": {
        "title": "Registration",
        "description": "Register your new account"
      }
    }
  }
}
